import React, {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import {useParams} from 'react-router-dom'
import Navbar from "../components/navbar"
import Menu from "../components/menu"
//---REDUX
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import allTheActions from '../actions'
//---
import TitleH1 from "../components/titleH1"
import calculCategorie from "../components/calculCategorie"
import FormLicenceCompetition from "../components/formLicenceCompetition"
import Swal from "sweetalert2"
import MenuMember from "../components/menuMember"

const LicenceView = props => {
    const id = useParams().id
    const [data, setData] = useState([])
    const [clubs, setClubs] = useState([])
    const history = useHistory()

    useEffect(() => {
        const fetchData = async () => {
            setData(await props.actions.licence.getLicenceById({id: id, idClub: localStorage.getItem('idClub')}))
        }
        fetchData()
    }, [props.actions.licence, id])

    useEffect(() => {
        const fetchData = async () => {
            const res = await props.actions.club.getAllClubs()
            setClubs(res.clubs)
        }
        fetchData()
    }, [props.actions.club])

    const handleChange = async event => {
        if (event.target.name === "dateNaissance") {
            const categorie = calculCategorie(event.target.value)
            setData({...data, categorie, [event.target.name]: event.target.value})
        } else setData({...data, [event.target.name]: event.target.value})
    }

    const handleSubmit = async event => {
        event.preventDefault()
        if(await props.actions.licence.updateLicence(data))
            Swal.fire(
                'Tout est bon !',
                'Mise à jour de la licence réussie !',
                'success'
            ).then(() => {
                if(data.idClub !== 'none') history.push(`/club/${data.idClub}`)
                else window.location.reload()
            })
    }

    return (
        <div>
            <Navbar/>
            {(localStorage.getItem("admin") === "true") ? <Menu/> : <MenuMember/>}
            <TitleH1 content={`${data.prenom} ${data.nom}`}/>
            <FormLicenceCompetition
                handleSubmit={handleSubmit}
                handleChange={handleChange}
                clubs={clubs} data={data}
                categorie={data.categorie}
                admin={(localStorage.getItem("admin") === "true")}
            />
        </div>
    )
}

const mapStateToProps = state => ({
    licenceState: state.licence,
    clubState: state.club
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        licence: bindActionCreators(allTheActions.licence, dispatch),
        club: bindActionCreators(allTheActions.club, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(LicenceView)
